import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import GlobalContext from "contexts/context";

import DatabaseContext from "data/contextDatabase";
import { randomString } from "hooks/helper";

const UITopicResult = (props) => {
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const { globalState } = useContext(GlobalContext);

  let history = useHistory();

  const sortJoin = (A, B, Delim) => {
    return A < B ? A + Delim + B : B + Delim + A;
  };

  const subscribeTopic = () => {
    let j = {
      version: globalState.version,
      type: "w.topic.subscribe.mtopic",
      source: "link",
      mtopic: props.topic.mtopic,
      smid: randomString(8),
    };
    databaseState.dbMaster &&
      databaseDispatch({
        type: "UPSERT_REC",
        values: {
          jmessage: j,
          db: databaseState.dbMaster,
          collection: "send",
          table: "confirm_smid",
          rowid: j.smid,
          doc: j,
        },
      });
  };

  let content = (
    <div className="UI-topic" onClick={() => subscribeTopic()}>
      <div style={{ color: "#333333" }}>{props.topic.topic}</div>
      {/* <div style={{ color: "#333333" }}>{props.topic.persona}</div> */}
      <div style={{ color: "#333333" }}>{props.topic.countsubs}</div>
    </div>
  );

  return content;
};

export default React.memo(UITopicResult, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
